import { useSearchParams } from 'react-router-dom'

import { BrandAssessment } from 'pages/BrandAssessment/BrandAssessment'
import { Development } from 'pages/Development/Development'
import { InsightsGathering } from 'pages/InsightsGathering/InsightsGathering'
import { ProjectSetUp } from 'pages/ProjectSetUp/ProjectSetUp'
import { WorkingModeSelection } from 'pages/WorkingModeSelection/WorkingModeSelection'

export const Process = () => {
  const [searchParams] = useSearchParams()

  if (searchParams.has('Brand Assessment')) {
    return <BrandAssessment />
  }

  if (searchParams.has('Project Set-Up')) {
    return <ProjectSetUp />
  }

  if (searchParams.has('Working Mode Selection')) {
    return <WorkingModeSelection />
  }

  if (searchParams.has('Insights Gathering')) {
    return <InsightsGathering />
  }

  if (searchParams.has('Development')) {
    return <Development />
  }

  return <div>Process Page</div>
}
